import { render } from "./DataRecordsField.vue?vue&type=template&id=1dbe4683"
import script from "./DataRecordsField.vue?vue&type=script&lang=js"
export * from "./DataRecordsField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__